import Pricing from "./Pricing.abi.json";
import ERC20 from "./ERC20.abi.json";
import Escrow from "./Escrow.abi.json";
import UniswapV3Factory from "./UniswapV3Factory.abi.json";
import UniswapV3Quoter from "./UniswapQuoterV3.abi.json";
import EscrowRouter from "./EscrowRouter.abi.json";

export default {
	ERC20,
	Pricing,
	Escrow,
	EscrowRouter,
	UniswapV3Factory,
	UniswapV3Quoter,
}
